import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, o, m, i, p, f) {
  return e(), t("svg", a, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25Zm0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm.159 6.75a.75.75 0 0 1 .743.648l.007.102-.001 3.5h.402a.75.75 0 0 1 .102 1.493l-.102.007H11a.75.75 0 0 1-.102-1.493L11 14.75h.408l.001-2.75h-.4a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .648-.743l.102-.007h1.15Zm-.307-3.253a1 1 0 0 1 .996.942l.002.058a1 1 0 1 1-1.004-1h.006Z"
    }, null, -1)
  ]));
}
const h = /* @__PURE__ */ l(n, [["render", s]]);
export {
  h as default
};
